
import { useState } from "react";
import SearchBar from "../UI/Searchbar";
import usePost from "./../../Hooks/usePost"
import API_ENDPOINTS from "../../Config/api";
import { toast } from 'react-toastify';
import ToggleButton from "../../Components/UI/ToggleButton";
import formatdate from "../../Utils/formatDate"
import capitalizeFirstLetter from "../../Utils/capitalizeFirstLetter";

export default function EnterpriseAssociatedTable({

    data,
    setData

}) {


    const [search, setSearch] = useState("");

    const { postData, loading } = usePost()

    const filteredRows = (data?.links ?? []).filter((item) => {
        const rs = (item?.enterprise?.ragione_sociale ?? "").toLowerCase();
        const em = (item?.enterprise?.email ?? "").toLowerCase();
        const q = search.toLowerCase();
        return rs.includes(q) || em.includes(q);
    });

    const handleToggleConsent = async (id) => {
        const current = (data?.links ?? []).find(l => l.id === id);
        if (!current) return;

        const newConsent = !Boolean(current.consent);

        try {
            await postData(API_ENDPOINTS.handleConsent(id), { consent: newConsent });
            toast.success("Consenso aggiornato con successo");

            setData(prev => {
                const prevLinks = prev?.links ?? [];
                return {
                    ...prev, links: prevLinks.map(l => l.id === id ? {
                        ...l,
                        consent: newConsent,
                        consent_at: newConsent ? new Date().toISOString() : null,
                    }
                        : l
                    )
                };
            });
        } catch (e) {
            toast.error("Errore durante l'aggiornamento del consenso");
        }
    };



    return (
        <>
            <div className="mb-4">
                <SearchBar search={search} setSearch={setSearch} />
            </div>

            <div className="flex flex-col h-[500px] ">
                <div className="flex-1 min-h-0 overflow-y-auto overflow-x-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
                    <table className="w-full table-auto text-sm text-slate-200 border-collapse min-w-[600px]">
                        <colgroup>
                            <col className="w-[50%]" /> {/* Ragione sociale */}
                            <col className="w-[20%]" /> {/* Email*/}
                            <col className="w-[10%]" /> {/* Stato monitoraggio */}
                            <col className="w-[10%]" /> {/* Data consenso*/}
                            <col className="w-[10%]" /> {/* Consenso*/}
                        </colgroup>

                        <thead className="text-black text-sm sticky top-0 z-10 bg-[#F3F4F7]">
                            <tr>
                                <th className="px-3 py-5 text-left font-medium whitespace-nowrap">Ragione sociale</th>
                                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Email</th>
                                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Stato monitoraggio</th>
                                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Data consenso</th>
                                <th className="px-3 py-5 text-center font-medium whitespace-nowrap">Consenso</th>
                            </tr>
                        </thead>


                        <tbody>
                            {filteredRows.length > 0 ? (
                                filteredRows.map((item, i) => (
                                    <Row
                                        key={i}
                                        item={item}
                                        onToggle={handleToggleConsent}
                                        toggling={loading}
                                    />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7} className="text-center py-6 text-slate-400">
                                        Nessun account Enterprise associato
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}





function Row({

    item,
    onToggle,
    toggling

}) {



    return (
        <tr className="text-black border-white border-b-4 bg-[#E3E3E3]">

            {/* Ragione sociale */}
            <td className="px-3 py-3 ">
                <p className="font-semibold leading-tight whitespace-nowrap">
                    {`${item.enterprise.ragione_sociale}` ?? "--"}
                </p>
            </td>

            {/* Email */}
            <td className="px-3 py-3 text-center tabular-nums">
                {`${item.enterprise.email}` ?? "--"}
            </td>

            {/* Stato monitoraggio */}
            <td className="px-3 py-3 text-center tabular-nums">
                <div
                    className={`inline-block px-2 py-1 w-full rounded font-medium text-sm
                              ${item.monitoring.active ?
                            "bg-green-100 text-green-800 border border-green-400"
                            :
                            "bg-red-100 border text-red-800 border-red-400"
                        }`}
                >
                    {item.monitoring.active ? "Richiesto" : "Dismesso"}
                </div>
            </td>



            {/* Data consenso */}
            <td className="px-3 py-3 text-center tabular-nums">
                {`${item.consent ? formatdate(item.consent_at) : '--'}` ?? "--"}
            </td>

            {/* Consenso */}
            <td className="px-3 py-3 text-center tabular-nums">
                <ToggleButton
                    checked={item.consent}
                    onToggle={() => onToggle(item.id)}
                    disabled={toggling}
                />
            </td>
        </tr>
    )
}